<template>
  <i18n-t keypath="NotificationsComponent.DoubleAllstatePremiumError" tag="span" class="pl-quarter" scope="global">
    <template #contactSupport>
      <button class="inline-btn-link" type="button" @click="goToUrl()">
        {{ t("NotificationsComponent.DoubleAllstatePremiumErrorContactSupport") }}
      </button>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { t } from "@/i18n";
import { getLanguageUrlParm } from "@/common/helper";
import { useUserStore } from "@/stores/user";

const componentName = "DoubleAllstatePremiumErrorNotification";

export default defineComponent({
  name: componentName,
  setup() {
    const userStore = useUserStore();
    const languageUrlParm = computed(() => getLanguageUrlParm(userStore.selectedLanguage || "en"));

    function goToUrl() {
      window.open(`https://www.webroot.com/${languageUrlParm.value}/support/support-home`, "_blank");
    }

    return { t, goToUrl };
  },
});
</script>
